<template lang="html">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
        <path :fill="color" d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2z M8.208,16.105h9.584v1.371
        H6.838V6.522h1.37V16.105z M9.919,14.423c-0.566,0-1.027-0.461-1.027-1.026c0-0.566,0.46-1.025,1.027-1.025
        c0.03,0,0.061,0,0.09,0.002l1.104-1.839c-0.105-0.161-0.167-0.354-0.167-0.561c0-0.566,0.46-1.027,1.027-1.027
        c0.566,0,1.028,0.46,1.028,1.027c0,0.207-0.063,0.399-0.168,0.561l1.104,1.839c0.028-0.002,0.06-0.002,0.088-0.002
        c0.022,0,0.045,0,0.068,0l1.823-3.188c-0.112-0.165-0.181-0.365-0.181-0.579c0-0.567,0.462-1.027,1.027-1.027
        c0.567,0,1.026,0.46,1.026,1.027s-0.459,1.027-1.026,1.027c-0.021,0-0.045,0-0.066-0.002l-1.824,3.189
        c0.113,0.164,0.18,0.365,0.18,0.578c0,0.565-0.46,1.026-1.027,1.026c-0.565,0-1.024-0.461-1.024-1.026
        c0-0.205,0.062-0.4,0.165-0.562l-1.103-1.839c-0.03,0.002-0.06,0.003-0.09,0.003c-0.03,0-0.061-0.001-0.089-0.003l-1.104,1.839
        c0.105,0.16,0.167,0.354,0.167,0.562C10.946,13.962,10.486,14.423,9.919,14.423z"/>
    </svg>
</template>

<script>
import { navIcon } from '@/functions/appColors';

export default {
    props: {
        color: {
            default: String(navIcon),
            type: String,
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/icons/Streamflow.vue